import type { MagicSearchEvent } from '@domain/magic-search';
import { nowUnix } from '@utils/now-unix';

export const isPastEvent = ({ startingTime, endingTime }: MagicSearchEvent, now: number = nowUnix()): boolean => {
  const lastMoment = endingTime ?? startingTime;
  return lastMoment !== null && lastMoment < now;
};
